module.exports = __webpack_public_path__ + "img/em-dos-dias-icon.1302a7cf.png";